<div class="ptkHistory">
<div class="history-toolbar">
    <div class="c-form__group c-form__group--icon u-osb-sm">
        <input-datepicker-new id="toolkitHistoryDateRange"
                              [(model)]="vm.historyDateRangeModel"
                              [hasTimepicker]="false"
                              [hasCalendarIcon]="false"
                              [minDate]="vm.historyDateRangeMin"
                              [isSmall]="true"
                              [isSingleDate]="false"
                              [isRequired]="false"
                              [isClearable]="true"
                              [placeholder]="'Toolkit.History.Filters.DateRange' | translate"
                              (modelChange)="vm.historyPage = 1"></input-datepicker-new>
    </div>
	<select class="history-filter-select" [(ngModel)]="vm.historyType" (ngModelChange)="vm.historyPage = 1">
		<option value="ALL">{{ 'Toolkit.History.Filters.Type.All' | translate }}</option>
		<option value="TOOLKIT">{{ 'Toolkit.History.Filters.Type.ExerciseOnly' | translate }}</option>
		<option value="SURVEY">{{ 'Toolkit.History.Filters.Type.SurveysOnly' | translate }}</option>
	</select>

	<select class="history-filter-select" [(ngModel)]="vm.historyItemId" (ngModelChange)="vm.historyPage = 1">
		<option value="ALL">{{ 'Toolkit.History.Filters.Item.All' | translate }}</option>
		<ng-container *ngIf="vm.historyType !== 'SURVEY'">
			<option *ngFor="let r of (vm.resources || [])" [value]="'toolkit:' + r.id">{{ r.title || r.name || r.id }}</option>
		</ng-container>
		<ng-container *ngIf="vm.historyType !== 'TOOLKIT'">
			<option *ngFor="let a of (vm.assessments || [])" [value]="'survey:' + a.id">{{ vm.assessmentLabel(a) || a.id }}</option>
		</ng-container>
	</select>

	<select class="history-filter-select" [(ngModel)]="vm.historyStatus" (ngModelChange)="vm.historyPage = 1">
		<option value="ALL">{{ 'Toolkit.History.Filters.Status.All' | translate }}</option>
		<option value="completed">{{ 'Toolkit.History.Status.Completed' | translate }}</option>
		<option value="overdue">{{ 'Toolkit.History.Status.Overdue' | translate }}</option>
		<option value="cancelled">{{ 'Toolkit.History.Status.Cancelled' | translate }}</option>
	</select>

	<input
		type="text"
		class="history-filter-search"
		placeholder="{{ 'Toolkit.History.Filters.Search.Placeholder' | translate }}"
		spellcheck="false"
		[(ngModel)]="vm.historySearch"
		(ngModelChange)="vm.historyPage = 1">

	<button class="filter-reset" type="button" (click)="reset()">{{ 'Toolkit.Provider.Filters.Reset' | translate }}</button>
</div>

<div class="history-summary">
	<ng-container *ngIf="summaryCounts() as s">
		<div class="item"><div class="num val-green">{{ s.completed }}</div><div class="lbl">{{ 'Toolkit.History.Summary.Completed' | translate }}</div></div>
		<div class="item"><div class="num val-orange">{{ s.overdue }}</div><div class="lbl">{{ 'Toolkit.History.Summary.Overdue' | translate }}</div></div>
		<div class="item"><div class="num" style="color:#888;">{{ s.cancelled }}</div><div class="lbl">{{ 'Toolkit.History.Summary.Cancelled' | translate }}</div></div>
		<div class="item"><div class="num val-blue">{{ s.total }}</div><div class="lbl">{{ 'Toolkit.History.Summary.Total' | translate }}</div></div>
		<div class="item"><div class="num val-purple">{{ s.surveysCompleted }}</div><div class="lbl">{{ 'Toolkit.History.Summary.SurveysCompleted' | translate }}</div></div>
		<div class="item"><div class="num">{{ s.rate }}%</div><div class="lbl">{{ 'Toolkit.History.Summary.Rate' | translate }}</div></div>
	</ng-container>
</div>

	<div class="history-table-wrap">
		<table class="history-table">
			<thead>
				<tr>
					<th>{{ 'Toolkit.History.Table.Date' | translate }}</th>
					<th>{{ 'Toolkit.History.Table.Client' | translate }}</th>
					<th>{{ 'Toolkit.Format.Exercise' | translate }}</th>
					<th>{{ 'Toolkit.History.Table.Type' | translate }}</th>
					<th>{{ 'Toolkit.History.Table.Status' | translate }}</th>
					<th>{{ 'Toolkit.History.Table.Result' | translate }}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let row of pagedRows">
					<td class="date-cell" [attr.data-label]="'Toolkit.History.Table.Date' | translate">
						{{ dateLabel(row).day }}
						<span class="time">{{ dateLabel(row).time }}</span>
					</td>
					<td [attr.data-label]="'Toolkit.History.Table.Client' | translate">{{ row.client }}</td>
					<td class="tool-cell" [attr.data-label]="'Toolkit.Format.Exercise' | translate">
						{{ truncateDescription(row.item) }}
						<span class="theme" *ngIf="row.theme">{{ truncateDescription(row.theme | translate) }}</span>
					</td>
					<td [attr.data-label]="'Toolkit.History.Table.Type' | translate">
						<span class="type-badge" [ngClass]="typeBadge(row).cls">{{ typeBadge(row).key | translate }}</span>
					</td>
					<td [attr.data-label]="'Toolkit.History.Table.Status' | translate">
						<span class="status-pill" [ngClass]="statusPill(row).cls">
							<span class="pill-dot"></span>{{ statusPill(row).key | translate }}
						</span>
					</td>
					<td class="result-cell" [attr.data-label]="'Toolkit.History.Table.Result' | translate">
						<ng-container *ngIf="row.resultPrimary; else noResult">
							<ng-container *ngIf="row.type === 'toolkit'">
								{{ row.resultPrimary }} {{ 'Toolkit.History.Result.Entries' | translate }}
							</ng-container>
							<ng-container *ngIf="row.type === 'survey'">
								{{ 'Toolkit.Common.Score' | translate }} {{ row.resultPrimary }}
							</ng-container>
						</ng-container>
						<ng-template #noResult>—</ng-template>
							<span class="sub" *ngIf="row.resultSecondary">
								<ng-container *ngIf="row.status !== 'completed'">{{ 'Toolkit.Common.Due' | translate }} </ng-container>{{ row.resultSecondary }}
							</span>
						</td>
					<td class="action-cell">
						<div class="row-actions">
							<button
								class="icon-btn"
								[title]="'Toolkit.Common.Open' | translate"
								type="button"
								[disabled]="!canOpen(row)"
								(click)="open(row)">
								<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
							</button>
						</div>
					</td>
					</tr>
				<tr *ngIf="!pagedRows.length">
					<td colspan="7" class="empty-cell">{{ 'Toolkit.History.Empty' | translate }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
